import React from 'react';

import { useFormContext } from 'react-hook-form';

import { TooltipIcon } from 'components/common/TooltipIcon/tooltipIcon';

import { FormValues } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.types';
import { Switch } from 'components/DesignSystem/Switch';

interface Props {
    canHaveAccess: boolean;
    hasAccess: boolean;
    firstName: string;
    username: string;
}

export const AllowAccessCell = ({ canHaveAccess, hasAccess, firstName, username }: Props) => {
    const { setValue, getValues } = useFormContext<FormValues>();

    if (!canHaveAccess)
        return (
            <TooltipIcon
                tooltip={{
                    infoList: `${firstName} doesn't have the access to the project data powering this report.`,
                    link: null,
                }}
                iconSize={'1.4rem'}
                size={'2.4rem'}
            />
        );

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const hasAccessNewState = event.target.checked;

        const usersAccessList = getValues('userAccessList');
        const updatedUserAccessInfo = usersAccessList.map((user) => {
            if (user.userName === username) {
                return {
                    ...user,
                    hasAccess: hasAccessNewState,
                    notifyOnUpload: hasAccessNewState,
                };
            } else {
                return user;
            }
        });

        setValue('userAccessList', updatedUserAccessInfo, { shouldDirty: true });
    };

    return <Switch onChange={handleChange} checked={hasAccess} />;
};
